const numbers = (value: any, mode: string = 'currency') => {
    let num;
    if (value) {
        if (typeof (value) !== 'string') {
            value = value.toString();
        }
        num = value
            .replace(/[^-.[0-9]/g, '')
            .replace(/(?!^)-/g, '');

        if (mode === 'digit') {
            num = (Math.round(+num.replace(/(\..*)\./g, '$1') * 100) / 100)
                .toFixed(1);
        } else if (mode === 'currency') {
            num = num.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        }
        return num;
    }
    return value;
};

export default numbers;
